import { gql } from "@apollo/client";

const GET_PRODUCT_LIST = gql`
  query getProductList($input: GetListInputV1) {
    getProductList(input: $input) {
      status
      error
      data {
        __typename
        ... on SellerProductListData {
          count
          productList {
            _id
            title
          }
        }
        ... on ProductListData {
          count
          productList {
            _id
            title
          }
        }
      }
    }
  }
`;
export default GET_PRODUCT_LIST;
